import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import Layout from '../layout';
import BaseCheckoutLayout from './base-checkout-layout';
import CheckoutStepCalculator from '../../services/checkout-step-calculator';

import Address from '../order/address';
import LineItem from '../order/line-item';
import Loader from '../shared/loader';

import APP_ROUTES from '../../constants/app-routes';
import spreeStore from '../../store';
import actions from '../../actions';
import ZoneService from '../../services/zone-service';
import { OrderErrorModal } from './modals';

class ConfirmationForm extends Component {
    constructor(props) {
        super(props);

        document.title = this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });

        this.state = {
            isFinalStepHappening: false,
        };
    }

    /* Render this step only if order is present and in a valid checkout state. */
    componentWillMount() {
        const { order } = this.props;

        if (!order.id) {
            this.props.redirectToCart();
        }

        if (!CheckoutStepCalculator.isStepEditable(order.checkout_steps, 'confirm', order.state)) {
            this.props.handleCheckoutStepNotEditable(order, this.props.placedOrder);
        }
        spreeStore.subscribe(() => {
            if (spreeStore.getState().order.isFinalStepHappening !== this.state.isFinalStepHappening) {
                this.setState({
                    isFinalStepHappening: spreeStore.getState().order.isFinalStepHappening,
                });
            }
        });
    }

    componentDidMount() {
        this.props.setCurrentCheckoutStep();
    }

    componentDidUpdate(prevProps) {
        if (this.props.locale !== prevProps.locale) {
            document.title = this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
        }
    }

    handleFormSubmit(formData) {
        if (!this.state.isFinalStepHappening) {
            spreeStore.dispatch(actions.setIsFinalStepHappening(true));
            window.scrollTo(0, 0);
            return this.props.handleFormSubmit(formData, this.props.order, this.props.locale.currentLocale).then(
                () => { },
                (error) => {
                    console.log(error);
                },
            ).finally(() => {
                spreeStore.dispatch(actions.setIsFinalStepHappening(false));
            });
        }
    }

    _shipmentLineItemsMarkup() {
        return this.props.stores && this.props.stores
            .filter((store) => this.props.order.line_items.findIndex((item) => item.attributes.store_id === store.id) !== -1)
            .map((store, index) => (
                <div style={{ paddingBottom: 30 }} key={index}>
                    <h3>
                        {store.name}
                    </h3>
                    <div>
                        {this.props.order.line_items
                            .filter((item) => item.attributes.store_id === store.id)
                            .map((lineItem, idx) => (
                                <LineItem lineItem={lineItem} key={idx} />))}
                    </div>
                </div>
            ));
    }

    render() {
        const {
            handleSubmit, valid, submitting, stores,
        } = this.props;

        const thereAreOutOfStockItems = this.props.order.line_items.some((item) => item.attributes.available === false);

        return (
            <Layout>
                <BaseCheckoutLayout
                    hasExtraTimeCheckout={this.props.hasExtraTimeCheckout}
                    gracePeriod={this.props.gracePeriod}
                    locale={this.props.locale.currentLocale}
                    currentStep="confirm"
                    displayLoader={this.props.displayLoader}
                    checkoutSteps={this.props.order.checkout_steps || []}
                    order={this.props.order}
                >
                    <OrderErrorModal
                        show={this.props.showDialogError}
                        onHide={this.props.onHideDialogError}
                        orderError={this.props.orderError}
                    />
                    {submitting && (
                        <div className="checkout-loading-container">
                            <FormattedMessage id="confirming" defaultMessage="Confirming" />
                            <Loader displayLoader size={36} />
                        </div>
                    )}
                    <form className="confirmation-form__container" onSubmit={handleSubmit(this.handleFormSubmit.bind(this))} style={{ display: submitting ? 'none' : 'inherit' }}>
                        <div className="row">
                            <div className="col-md-6">
                                <h4>
                                    <FormattedMessage id="billingAddress" defaultMessage="Billing Address" />
                                    :
                                </h4>
                                {this.props.order.bill_address && (
                                    <Address address={this.props.order.bill_address} />
                                )}
                            </div>
                            {!ZoneService.isDonationZone() && (
                                <div className="col-md-6">
                                    <h4>
                                        <FormattedMessage id="shippingAddress" defaultMessage="Shipping Address" />
                                        :
                                    </h4>
                                    {this.props.order.ship_address && (
                                        <Address address={this.props.order.ship_address} />
                                    )}
                                </div>
                            )}
                        </div>
                        <hr />
                        <div className="form-group">
                            <div className="col-md-12">
                                <h4>
                                    <FormattedMessage id="orderItems" defaultMessage="Order Items" />
                                </h4>
                                {this._shipmentLineItemsMarkup()}
                            </div>
                        </div>
                        <div className="buttons-container buttons-container-confirm" style={{ position: 'relative', top: '20px' }}>
                            <Link to={APP_ROUTES.checkout.paymentPageRoute}>
                                <button
                                    type="button"
                                    className="button--outlined"
                                    style={{ marging: 30 }}
                                >
                                    <FormattedMessage id="back" defaultMessage="Back" />
                                </button>
                            </Link>
                            <button type="submit" disabled={!valid || submitting || this.state.isFinalStepHappening /* || thereAreOutOfStockItems */} className="button--reverted">
                                <span className="checkout-button-text__desktop"><FormattedMessage id="confirmOrder" defaultMessage="Confirm your Order" /></span>
                                <span className="checkout-button-text__mobile"><FormattedMessage id="confirmOrderMobile" defaultMessage="Confirm" /></span>
                            </button>
                        </div>
                    </form>
                </BaseCheckoutLayout>
            </Layout>
        );
    }
}

ConfirmationForm = reduxForm({
    form: 'confirmationForm',
})(ConfirmationForm);

export default injectIntl(ConfirmationForm);



/** WEBPACK FOOTER **
 ** ./src/components/checkout-steps/confirmation-form.jsx
 **/